// extracted by mini-css-extract-plugin
export default {"article-container":"Articles_article-container__xcAi2","article-list":"Articles_article-list__sfkbb"};